import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-container',
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.css'],
})
export class ModalContainerComponent implements OnInit {
  @Input() modalContainer: TemplateRef<any>;
  @Input() cancelButton: boolean = false;
  @Input() size: number = 1;
  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {}

  openModal(modal?) {
    let sizeString = 'md';
    let windowClass = '';
    switch (this.size) {
      case 2:
        sizeString = 'lg';
        break;
      case 3:
        sizeString = 'xl';
        break;
      case 4:
        sizeString = 'xl';
        windowClass = 'modal-factura-wide';
        break;
      default:
        break;
    }

    const content = modal ? modal : this.modalContainer;
    if (!content) { return; }

    const options: any = { size: sizeString, centered: true };
    if (windowClass) {
      options.windowClass = windowClass;
    }
    if (this.cancelButton) {
      options.backdrop = 'static';
      options.keyboard = false;
    }

    this.modalService.open(content, options);

  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
